import { IMedia } from './media'

export interface ICard {
  name: string
  backgroundColor: string
  url: string
}

export interface ISimpleCard extends ICard {
  iconColor: string
  iconSource?: IMedia | null
}

export interface IExtendedCard extends ISimpleCard {
  childList: IWebMenu[]
}

export interface IBreadcrumb {
  text: string
  url: string
}

export interface IWebMenu {
  id: string
  name_HU: string
  name_EN: string
  url_HU: string
  url_EN: string
  backgroundColor: string
  iconColor: string
  fontColor: string
  type: WebMenuTypeEnum
  parent: string | null
  iconUrl?: string
  isExtended?: boolean
  breadcrumbs_HU: IBreadcrumb[]
  breadcrumbs_EN: IBreadcrumb[]
  childList?: IWebMenu[]
  visible: boolean
  openNewTab: boolean
  link: string
}

export enum WebMenuTypeEnum {
  HOME = 'HOME',
  ACCESSIBILITYSTATEMENT = 'ACCESSIBILITYSTATEMENT',
  ARTICLELIST = 'ARTICLELIST',
  ARTICLE = 'ARTICLE',
  ACTIVITY_LIST = 'ACTIVITY_LIST',
  ACTIVITY = 'ACTIVITY',
  PHOTOGALLERY = 'PHOTOGALLERY',
  PHOTOGALLERYLIST = 'PHOTOGALLERYLIST',
  VIDEOGALLERYLIST = 'VIDEOGALLERYLIST',
  VIDEOGALLERY = 'VIDEOGALLERY',
  GENERALLIST = 'GENERALLIST',
  FILELIST = 'FILELIST',
  MAP = 'MAP',
  CITYCARD = 'CITYCARD',
  IMPRESSUM = "IMPRESSUM",
  PRIVACYPOLICY = 'PRIVACYPOLICY',
  SEARCH = 'SEARCH',
  PAGEMAP = 'PAGEMAP'
}

export enum WebmenuPathEnum {
  HOME = '/',
  ACCESSIBILITYSTATEMENT = '/article',
  ACTIVITY = `/activity`,
  ACTIVITY_LIST = `/activity-list`,
  ARTICLE = `/article`,
  ARTICLELIST = `/article-list`,
  PHOTOGALLERY = `/photo-gallery`,
  PHOTOGALLERYLIST = `/photo-gallery-list`,
  VIDEOGALLERY = `/video-gallery`,
  VIDEOGALLERYLIST = `/video-gallery-list`,
  GENERALLIST = '/general-list',
  FILELIST = '/file-list',
  MAP = `/map`,
  CITYCARD = `/citycard`,
  IMPRESSUM = `/imprint`,
  SEARCH = `/search`,
  PAGEMAP = `/sitemap`,
  PRIVACYPOLICY = '/privacy-policy'
}

// todo add data of other static pages, like impressum, sitemap, etc
export const HOME_PAGE_DATA = {
  id: 'HOME',
  name_HU: 'Főoldal',
  name_EN: 'Homepage',
  url_HU: '/',
  url_EN: '/',
  backgroundColor: '',
  iconColor: '#FFFFFFF',
  fontColor: '#FFFFFFF',
  type: WebMenuTypeEnum.HOME,
  parent: null,
  breadcrumbs_HU: [],
  breadcrumbs_EN: [],
  childList: [],
  visible: true,
  openNewTab: false,
  link: ''
}

export const isTypeWithSlug = (type: WebMenuTypeEnum) =>
  type === WebMenuTypeEnum.ARTICLE ||
  type === WebMenuTypeEnum.PHOTOGALLERY ||
  type === WebMenuTypeEnum.VIDEOGALLERY ||
  type === WebMenuTypeEnum.ACTIVITY

export const isRelatedArticleWithoutSlug = (type: WebMenuTypeEnum) => {
  return type === WebMenuTypeEnum.PHOTOGALLERY ||
    type === WebMenuTypeEnum.PHOTOGALLERYLIST ||
    type === WebMenuTypeEnum.FILELIST ||
    type === WebMenuTypeEnum.VIDEOGALLERY ||
    type === WebMenuTypeEnum.VIDEOGALLERYLIST ||
    type === WebMenuTypeEnum.GENERALLIST ||
    type === WebMenuTypeEnum.ACCESSIBILITYSTATEMENT
}
